import { render, staticRenderFns } from "./custom-ximg.vue?vue&type=template&id=30eba0f7&"
import script from "./custom-ximg.vue?vue&type=script&lang=js&"
export * from "./custom-ximg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports